import { getFilterNameFn } from '@components/dimension-panel-hz/drawer/utils';
import { filterColors } from '@utils';
import { COMPARE_TYPES } from '@store/trends/base/reducer';
import { isEmpty, get } from 'lodash';

export const COMPARE_SERIES_LIMIT = 20;
export const COMPARE_SERIES_PREFIX = 'compare-series';

export const getCompareSeriesId = (idx) => `${COMPARE_SERIES_PREFIX}-${idx}`;

// compare series placeholders
export const COMPARE_SERIES = Array(COMPARE_SERIES_LIMIT)
  .fill(null)
  .map((_, idx) => ({
    id: getCompareSeriesId(idx),
    type: 'line',
  }));

const getFilterName = getFilterNameFn(COMPARE_TYPES.trends);

export function buildCompareSeries(
  seriesData,
  { xAxisIndex = 0, yAxisIndex = 0, compareFilters, barChart, compareFiltersMetaMap },
) {
  const baseSeries: any = COMPARE_SERIES.map((s) => ({ ...s, data: [] }));

  if (!isEmpty(seriesData)) {
    seriesData.forEach((data, idx) => {
      // if at least one filter is highlighted
      // decrease opacity on all other filters
      const hasHighlightedFilter = compareFilters.some(
        ({ meta = { highlight: false } }) => meta.highlight,
      );

      // is the current filter highlighted
      const filterMeta = compareFiltersMetaMap.get(compareFilters[idx].rule) || {};
      const highlight = get(filterMeta, ['highlight'], false);

      baseSeries[idx] = {
        id: getCompareSeriesId(idx),
        name: getFilterName(compareFilters[idx]),
        data,
        type: barChart ? 'bar' : 'line',
        symbol: 'circle',
        showSymbol: false,
        showBackground: false,
        xAxisIndex,
        yAxisIndex,
        itemStyle: {
          color: filterColors[idx] || '#606200',
        },
        lineStyle: {
          width: 1.5,
          opacity: hasHighlightedFilter && !highlight ? 0.3 : 1,
        },
        areaStyle: {
          opacity: highlight ? 0.2 : 0,
        },
        markLine: {},
        triggerLineEvent: true,
      };
    });
  }

  return baseSeries;
}
